<template>
    <div v-if="null != hallInfo && null != cardList">
        <ExhibitorCover
            :obj="hallInfo"
            @print-complete="coverPrintCallback"
        />

        <ExhibitorPager
            :list="cardList"
            @print-complete="contentPrintCallback"
        />
    </div>
</template>

<script setup>

import {onMounted, onBeforeMount, ref} from "vue";
import ExhibitorCover from "@/components/shopopee/print/format/exhibitor/exhibitorCover.vue";
import ExhibitorPager from "@/components/shopopee/print/format/exhibitor/exhibitorPager.vue";
import { jsPDF } from "jspdf";
import record14Api from "@/request/record14Api";
import cardApi from "@/request/api";
import myUtil from "@/util/util";

const props = defineProps(["hallId"])
const emits = defineEmits(["print-complete"])

const hallInfo = ref(null)
const cardList = ref(null)

let coverImg = null
let contentImgList = null

function getHallInfo(){
    const request = record14Api.getRecord14List
    const params = request.getParams()

    params.recordno = "-1"
    params.addinfo17 = null
    params.id = props.hallId

    request.send(params, (res) => {
        if (res.code == 200){
            if (null != res.detail && res.detail.length > 0){
                hallInfo.value = res.detail[0]
            }
        }
    })
}

function getCardList(){
    const request = cardApi.queryByHall
    const params = request.getParams()

    params.updatedid = props.hallId

    request.send(params, (res) => {
        if (res.code == 200){
            cardList.value = res.detail
        }
    })

}

function coverPrintCallback(url){
    coverImg = url
    if (null != coverImg && null != contentImgList){
        printPage()
    }
}

function contentPrintCallback(list){
    contentImgList = list

    if (null != coverImg && null != contentImgList){
        printPage()
    }
}

function printPage(){
    const pdf = new jsPDF("p", "px", [2480, 3504]);
    pdf.addImage(coverImg, 0, 0, 2480, 3504)

    if (null != contentImgList && contentImgList.length > 0){
        pdf.addPage()

        contentImgList.forEach((v, i) => {
            pdf.addImage(v, 0, 0, 2480, 3504)

            if (i < contentImgList.length - 1){
                pdf.addPage()
            }
        })
    }

    pdf.save(`${hallInfo.value.recordname}.pdf`)
    emits("print-complete")
}

onBeforeMount(() => {
    if (myUtil.isNotEmpty(props.hallId)){
        getHallInfo()
        getCardList()
    }
})

</script>

<style scoped>

</style>